import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface LoginOrRegisterData {
  loginOrRegister: {
    id: GQL_ID
    timeout: number
    sent: boolean
    error?: string | null
  }
}

interface LoginOrRegisterVariables {
  phone: string
  token: string
}

export const GQL_MUTATION_LOGIN_OR_REGISTER = gql`
  mutation LoginOrRegister($phone: String!, $token: String!) {
    loginOrRegister(phone: $phone, token: $token) {
      id
      timeout
      sent
      error
    }
  }
`

export const useLoginOrRegister = () =>
  useMutation<LoginOrRegisterData, LoginOrRegisterVariables>(GQL_MUTATION_LOGIN_OR_REGISTER)
